const features = [
  {
    icon: 'ri-leaf-line',
    title: 'Économies d\'Énergie',
    description: 'Récupération de chaleur jusqu\'à 95%, réduction de 30% des coûts de chauffage. Investissement rentabilisé en quelques années.',
    stat: '-30%',
    statLabel: 'Coûts chauffage',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Air Sain',
    description: 'Filtration des pollens, allergènes et particules fines. Renouvellement d\'air constant pour un environnement sain et confortable.',
    stat: 'F7',
    statLabel: 'Filtration',
  },
  {
    icon: 'ri-volume-mute-line',
    title: 'Silence Total',
    description: 'Systèmes ultra-silencieux 25 dB(A), isolation phonique optimale. Confort acoustique garanti jour et nuit, sans nuisance.',
    stat: '25 dB',
    statLabel: 'Niveau sonore',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Maintenance Simple',
    description: 'Entretien simple, changement de filtres annuel. Contrats de maintenance disponibles pour une tranquillité totale sur le long terme.',
    stat: '1×/an',
    statLabel: 'Entretien',
  },
];

export default function VentilationFeatures() {
  return (
    <section className="py-20 bg-gray-950">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/25 rounded-full px-4 py-1.5 mb-5">
              <i className="ri-windy-line text-amber-400 text-sm"></i>
              <span className="text-xs font-bold tracking-widest uppercase text-amber-400">Avantages VMC</span>
            </div>
            <h2 className="text-3xl font-bold text-white sm:text-4xl">
              Les avantages de la<br />
              <span className="text-amber-400">VMC double flux</span>
            </h2>
          </div>
          <p className="text-gray-400 text-sm max-w-sm leading-relaxed">
            Confort, santé et économies pour votre habitation à Genève et en Suisse romande.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <div key={i} className="bg-gray-900 rounded-2xl p-6 border border-white/5 hover:border-amber-500/30 transition-all group">
              <div className="flex items-start justify-between mb-5">
                <div className="w-11 h-11 flex items-center justify-center bg-amber-500/15 border border-amber-500/30 rounded-xl group-hover:bg-amber-500 group-hover:border-amber-500 transition-all">
                  <i className={`${f.icon} text-amber-400 group-hover:text-white transition-colors`}></i>
                </div>
                <div className="text-right">
                  <div className="text-xl font-bold text-amber-400">{f.stat}</div>
                  <div className="text-xs text-gray-500">{f.statLabel}</div>
                </div>
              </div>
              <h3 className="text-sm font-bold text-white mb-2">{f.title}</h3>
              <p className="text-gray-400 text-xs leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>

        {/* Banner */}
        <div className="mt-10 flex flex-col sm:flex-row items-center gap-6 bg-amber-500/8 border border-amber-500/20 rounded-2xl px-8 py-6">
          <div className="w-12 h-12 flex items-center justify-center bg-amber-500 rounded-xl shrink-0">
            <i className="ri-windy-line text-white text-xl"></i>
          </div>
          <div className="flex-1 text-center sm:text-left">
            <h3 className="text-base font-bold text-white mb-1">Installation et mise en service complète incluse</h3>
            <p className="text-gray-400 text-sm">Pose du réseau de gaines, raccordements, réglages des débits et équilibrage du système. Formation à l'utilisation offerte.</p>
          </div>
          <a href="#contact" className="shrink-0 inline-flex items-center gap-2 rounded-lg bg-amber-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-amber-600 transition-all whitespace-nowrap cursor-pointer">
            Demander un devis
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
